import { data } from 'jquery';
import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import {Asistencia,RequestResponseGetAllAsistencias} from 'src/app/shared/models/gestor-asistencia/gestor-asistencia.interface';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';


@Injectable({
  providedIn: 'root'
})
export class GestorAsistenciaService {

  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }
  //ObtenerTodo
  obtenerTodoCalendario(): Observable<RequestResponseGetAllAsistencias> {
    return this.http
    .get<RequestResponseGetAllAsistencias >(`${environment.API}/rrhh/calendario`)
    .pipe(
      map((res:RequestResponseGetAllAsistencias) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //ObtenerTodoAsync
  async obtenerTodoCalendarioAsync(): Promise<RequestResponseGetAllAsistencias>{
    try {
      return await this.http.get<RequestResponseGetAllAsistencias>(`${environment.API}/rrhh/calendario`).toPromise();
    } catch (error) {
      console.error(error);
      return {success: false, msg: 'Hubo un error al obtener la asistencia'} as RequestResponseGetAllAsistencias
    }
  }
  //crear
  crearRegistroCalendario(asistencia:Asistencia): Observable<RequestResponse> {
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/calendario/crear`,asistencia)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Eliminar
  eliminarRegistroCalendario(id:number): Observable<RequestResponse> {
    return this.http
    .delete<RequestResponse >(`${environment.API}/rrhh/calendario/eliminar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorId
  traerRegistroPorId(id:any): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/calendario/buscar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //getDiasFaltados
  traerDiasFaltados(id:any, mes:any, year:any): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/calendario/diasfaltados/${id}/${mes}/${year}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //ObtenerAsistenciaPeriodo
  obtenerAsistenciaPeriodo(id:number, fecha: Date){
    const mes = fecha.getMonth() + 1;
    const year = fecha.getFullYear();
    return this.http
    .get<RequestResponseGetAllAsistencias>(`${environment.API}/rrhh/calendario/asistenciaperiodo/${id}/${mes}/${year}`)
    .pipe(
      map((res:RequestResponseGetAllAsistencias) => res),
      catchError((err)=> this.handlerError(err))
    );
  }
  //ObtenerAsistenciaPeriodoAsync
  async obtenerAsistenciaPeriodoAsync(id:number, fecha: Date): Promise<RequestResponse>{
    try {
      const mes = fecha.getMonth() + 1;
      const year = fecha.getFullYear();
      return await this.http.get<RequestResponseGetAllAsistencias>(`${environment.API}/rrhh/calendario/asistenciaperiodo/${id}/${mes}/${year}`).toPromise();
    } catch (error) {
      console.error(error);
      return ({success: false, msg: 'Hubo un error al obtener los datos de Asistencia'} as RequestResponse);
    }
  }
  //buscarPorRut
  async buscarIdTrabajador(id: number): Promise<RequestResponseGetAllAsistencias>{
    try {
      return await this.http.get<RequestResponseGetAllAsistencias>(`${environment.API}/rrhh/calendario/idTrabajador/${id}`).toPromise();
    } catch (error) {
      console.error(error);
      return {success: false, msg: 'Hubo un error al obtener la asistencia'} as RequestResponseGetAllAsistencias
    }
  }
  //ActualizarAsistencia
  actualizarAsistencia(asistencia:any): Observable<RequestResponse>  {
    return this.http
    .put<RequestResponse>(`${environment.API}/rrhh/calendario/actualizar/ ${asistencia.cp_calendario}`,asistencia)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //ESTO NO PERTENECE AQUI, PERO SI LO QUITO, SE CAE XD
  TraerTrabajadores(): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/trabajador`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerRazonId SE COMENTA PORQUE NO SE LLAMA EN NI UNA PARTE Y LA RUTA EN BACK ESTÁ COMENTADA

  // TraerRazonId(): Observable<RequestResponse> {
  //   return this.http
  //   .get<RequestResponse>(`${environment.API}/rrhh/razon`)
  //   .pipe(
  //     map((res:RequestResponse) =>{
  //       return res;
  //     }),
  //     catchError((err)=> this.handlerError(err))
  //   );
  // }
  
  //lista_razon
  listarRazones(): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/razon/listar`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
    }

  private handlerError(err: any):Observable<never>{

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }
}
